// == Mini-Cart Upsell: Variante wählen + per AJAX hinzufügen ==
(function () {
  if (window.__upsellBound) return; // doppelte Bindung vermeiden
  window.__upsellBound = true;

  console.log('[Upsell] Handler gebunden');

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-add-upsell]');
    if (!btn) return;

    console.log('[Upsell] Klick erkannt');

    const wrap = btn.closest('.upsell-form');
    const picker = wrap && wrap.querySelector('.upsell-variant-id');
    const variantId = picker ? (picker.value || picker.getAttribute('value')) : null;

    if (!variantId) {
      console.warn('[Upsell] Keine Variant-ID gefunden');
      return;
    }

    btn.disabled = true;
    btn.classList.add('loading');

    try {
      // 1) AJAX /cart/add
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!addRes.ok) {
        const msg = await addRes.text();
        console.error('[Upsell] /cart/add.js Fehler:', msg);
        return;
      }

      console.log('[Upsell] Hinzugefügt, Sections werden neu geladen');

      // 2) Drawer & Bubbles neu laden
      const secRes = await fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble');
      const sections = await secRes.json();

      const mini = document.querySelector('mini-cart');
      if (mini && typeof mini.renderContents === 'function') {
        mini.renderContents({ id: Date.now(), sections });
      } else {
        const target = document.getElementById('mini-cart');
        if (target && sections['mini-cart']) {
          target.innerHTML = new DOMParser()
            .parseFromString(sections['mini-cart'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
      }
    } catch (err) {
      console.error('[Upsell] Ausnahme:', err);
    } finally {
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  });
  // Preis aktualisieren, wenn im Upsell die Variante gewechselt wird
document.addEventListener('change', (e) => {
  const select = e.target.closest('.upsell-variant-id');
  if (!select) return;

  // statt innerhalb .upsell-form suchen wir in der gemeinsamen Hülle
  const scope =
    select.closest('.product-description') || // hier liegen beide Blöcke
    select.closest('.product-container')     ||
    document;

  const priceEl = scope.querySelector('.upsell-price .price');
  if (!priceEl) return;

  const opt   = select.options[select.selectedIndex];
  const price = opt?.dataset?.price;
  if (price) priceEl.innerHTML = price;
});
function syncUpsellPrices() {
  document.querySelectorAll('.upsell-form').forEach((form) => {
    const select  = form.querySelector('.upsell-variant-id');
    const scope   = form.closest('.product-description') || form.closest('.product-container') || document;
    const priceEl = scope.querySelector('.upsell-price .price');
    if (!select || !priceEl) return;
    const opt = select.options[select.selectedIndex];
    if (opt?.dataset?.price) priceEl.innerHTML = opt.dataset.price;
  });
}
document.addEventListener('cartdrawer:opened', syncUpsellPrices);


})();
